<div class="memo-sections">
  @if (assignmentMemos().length > 0) {
    <div class="memo-section">
      <h3 class="memo-section-title">{{ 'MEMO.DTO.ASSIGNMENT_TITLE' | translate }}</h3>
      <div class="memo-list">
        @for (memo of assignmentMemos(); track memo.Id) {
          <div class="memo-item" [class.selected]="memo === expandedMemo">
            <div class="memo-item-header">
              <span class="memo-item-title">Memo: {{ memo.Subject }}</span>
              <div class="memo-item-buttons">
                <dx-button
                  class="expand-button"
                  (onClick)="expandMemo(memo)"
                  [disabled]="isBusy()"
                  [text]="
                    expandedMemo === memo ? ('MEMO.DTO.COLLAPSE' | translate) : ('MEMO.DTO.EXPAND' | translate)
                  "></dx-button>
              </div>
            </div>
            @if (expandedMemo === memo && formType === 'edit') {
              <div class="memo-item-content">
                <form>
                  <dx-form
                    id="form"
                    class="form last plain-styled-form"
                    [formData]="formData"
                    labelMode="floating"
                    [(isDirty)]="isDirty">
                    <dxi-item itemType="group" [colCount]="2">
                      <dxi-item
                        dataField="Subject"
                        editorType="dxTextBox"
                        [isRequired]="true"
                        [editorOptions]="{ readOnly: true }">
                        <dxo-label [text]="'MEMO.DTO.BETREFF' | translate"></dxo-label>
                      </dxi-item>
                      <dxi-item dataField="CreatedBy" editorType="dxTextBox" [editorOptions]="{ readOnly: true }">
                        <dxo-label [text]="'MEMO.DTO.BETRUSER' | translate"></dxo-label>
                      </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="2">
                      <dxi-item dataField="CreatedAt" editorType="dxDateBox" [editorOptions]="{ readOnly: true }">
                        <dxo-label [text]="'MEMO.DTO.ERFASSUNGSDATUM' | translate"></dxo-label>
                      </dxi-item>
                      <dxi-item dataField="ChangedBy" editorType="dxTextBox" [editorOptions]="{ readOnly: true }">
                        <dxo-label [text]="'MEMO.DTO.ERFASSUNGSUSER' | translate"></dxo-label>
                      </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="1">
                      <dxi-item
                        dataField="MemoText"
                        editorType="dxTextArea"
                        [isRequired]="true"
                        [editorOptions]="{ height: 200, readOnly: true }">
                        <dxo-label [text]="'MEMO.DTO.MEMOTEXT' | translate"></dxo-label>
                      </dxi-item>
                    </dxi-item>
                  </dx-form>
                </form>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  <div class="memo-section">
    @if (internalMemos().length > 0 || (newMemo && formType === 'create')) {
      <h3 class="memo-section-title">{{ 'MEMO.DTO.INTERNAL_TITLE' | translate }}</h3>
      <div class="memo-list">
        @for (memo of internalMemos(); track memo.Id) {
          <div class="memo-item" [class.selected]="memo === expandedMemo">
            <div class="memo-item-header">
              <span class="memo-item-title">Memo: {{ memo.Subject }}</span>
              <div class="memo-item-buttons">
                <dx-button
                  class="expand-button"
                  (onClick)="expandMemo(memo)"
                  [disabled]="isBusy()"
                  [text]="
                    expandedMemo === memo ? ('MEMO.DTO.COLLAPSE' | translate) : ('MEMO.DTO.EXPAND' | translate)
                  "></dx-button>
              </div>
            </div>
            @if (expandedMemo === memo && formType === 'edit') {
              <div class="memo-item-content">
                <form>
                  <dx-form
                    id="form"
                    class="form last plain-styled-form"
                    [formData]="formData"
                    labelMode="floating"
                    [(isDirty)]="isDirty">
                    <dxi-item itemType="group" [colCount]="2">
                      <dxi-item dataField="Subject" editorType="dxTextBox" [isRequired]="true">
                        <dxo-label [text]="'MEMO.DTO.BETREFF' | translate"></dxo-label>
                      </dxi-item>
                      <dxi-item dataField="CreatedBy" editorType="dxTextBox" [editorOptions]="{ readOnly: true }">
                        <dxo-label [text]="'MEMO.DTO.BETRUSER' | translate"></dxo-label>
                      </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="2">
                      <dxi-item dataField="CreatedAt" editorType="dxDateBox" [editorOptions]="{ readOnly: true }">
                        <dxo-label [text]="'MEMO.DTO.ERFASSUNGSDATUM' | translate"></dxo-label>
                      </dxi-item>
                      <dxi-item dataField="ChangedBy" editorType="dxTextBox" [editorOptions]="{ readOnly: true }">
                        <dxo-label [text]="'MEMO.DTO.ERFASSUNGSUSER' | translate"></dxo-label>
                      </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="1">
                      <dxi-item
                        dataField="MemoText"
                        editorType="dxTextArea"
                        [isRequired]="true"
                        [editorOptions]="{ height: 200 }">
                        <dxo-label [text]="'MEMO.DTO.MEMOTEXT' | translate"></dxo-label>
                      </dxi-item>
                    </dxi-item>
                  </dx-form>
                </form>
                <div class="container">
                  <dx-button
                    class="submit-button"
                    (onClick)="save()"
                    [disabled]="!isDirty || isBusy()"
                    [text]="'SHARED.SAVE' | translate"></dx-button>
                  <dx-button
                    class="delete-button"
                    (onClick)="delete()"
                    [disabled]="isBusy()"
                    [text]="'SHARED.DELETE' | translate"></dx-button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="memo-item-buttons">
    <dx-button
      class="create"
      (onClick)="createNewMemo()"
      [disabled]="isBusy()"
      [text]="'MEMO.DTO.CREATE' | translate"></dx-button>
  </div>

  @if (newMemo && formType === 'create') {
    <div class="memo-item new-memo">
      <div class="memo-item-header">
        <span class="memo-item-title">{{ 'MEMO.DTO.CREATE_MEMO' | translate }}</span>
      </div>
      <div class="memo-item-content">
        <form>
          <dx-form
            id="form"
            class="form last plain-styled-form"
            [formData]="formData"
            labelMode="floating"
            [(isDirty)]="isDirty">
            <dxi-item itemType="group" [colCount]="1">
              <dxi-item dataField="Subject" editorType="dxTextBox" [isRequired]="true">
                <dxo-label [text]="'MEMO.DTO.BETREFF' | translate"></dxo-label>
              </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colCount]="1">
              <dxi-item
                dataField="MemoText"
                editorType="dxTextArea"
                [isRequired]="true"
                [editorOptions]="{ height: 200 }">
                <dxo-label [text]="'MEMO.DTO.MEMOTEXT' | translate"></dxo-label>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </form>
        <div class="container">
          <dx-button
            class="submit-button"
            (onClick)="save()"
            [disabled]="!isDirty || isBusy()"
            [text]="'SHARED.SAVE' | translate"></dx-button>
          <dx-button
            class="cancel-button"
            (onClick)="cancelNewMemo()"
            [disabled]="isBusy()"
            [text]="'MEMO.DTO.CANCEL' | translate"></dx-button>
        </div>
      </div>
    </div>
  }
</div>
